import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';
import { CommonServices } from '../Common/CommonServices';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTwoDecimalWithMaxLimit]',
  standalone: false
})
export class TwoDecimalWithMaxLimitDirective {

  @Input() maxLimit: number | null = null;

  constructor(
    private el: ElementRef,
    private commonServices: CommonServices,
    @Optional() private ngControl: NgControl
  ) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    let value = input.value;
    let modified = false;

    // Allow only one dot and numeric characters
    if (value.split('.').length > 2 || /[^0-9.]/.test(value)) {
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
      modified = true;
    }

    const afterDecimal = value.split('.')[1];
    if (afterDecimal && afterDecimal.length > 2) {
      value = value.substring(0, value.indexOf('.') + 3);
      modified = true;
    }

    if (value === '000') {
      value = '00';
      modified = true;
    }

    if (this.maxLimit !== null && Number(value) > this.maxLimit) {
      value = this.maxLimit.toString();
      modified = true;

      this.commonServices.showMessage(
        'error',
        `Maximum Allowed Lucky Bucks are ${this.maxLimit} at a time.`,
        10
      );
    }

    if (modified) {
      input.value = value;
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(value, { emitEvent: false });
      }
    }
  }
}